import React, { Component } from "react";
import "./SwitchToggle.less";

class SwitchToggle extends Component {
  render() {
    const { name, checked, onChange, labelOff, labelOn } = this.props;

    return (
      <div className="switch-toggle">
        {labelOff && <span className="switch-toggle__label">{labelOff}</span>}
        <label className="switch-toggle__container">
          <input
            type="checkbox"
            name={name}
            checked={checked}
            onChange={onChange}
          />
          <span className="switch-toggle__slider"></span>
        </label>
        {labelOn && <span className="switch-toggle__label">{labelOn}</span>}
      </div>
    );
  }
}

export default SwitchToggle;